import { connect } from 'react-redux'
import { getRegistryId } from '../../reducers'
import { ChecklistOverview, ChecklistThemesList } from './components'

interface RegistryChecklistAppProps {
  registryId: number
}

interface State {
  registry: {
    id: number
  }
}

export const RegistryChecklistApp = ({
  registryId,
}: RegistryChecklistAppProps) => (
  <>
    <ChecklistOverview registryId={registryId} />
    <ChecklistThemesList registryId={registryId} />
  </>
)

const mapStateToProps = (state: State) => ({
  registryId: getRegistryId(state),
})

export default connect(mapStateToProps)(RegistryChecklistApp)
